import { useEffect, useState } from "react";

import internalServerErrorLottie from "assets/files/internal-server-erorr-lottie.json";
import loadingWholeAppLottie from "assets/files/loading-whole-app-lottie.json";
import { ColorVariables, Paths, zIndexes } from "configs";
import { useAuth, useDidMountWithoutLifeCycle } from "hooks";
import Lottie from "lottie-react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "stores";

/**
 * Do things that is required for the app iniatilly.
 * e.g. take token, fetch user info, etc.
 */
export const AppInitializer = () => {
  const location = useLocation();
  const [loadedWholeApp, setLoadedWholeApp] = useState(false);
  const { internalServerError } = useAppSelector((state) => state.system);
  const { isInitializing, initUserSession } = useAuth();

  useDidMountWithoutLifeCycle(() => {
    if (location.pathname.startsWith(Paths.Public.FormLibrary)) return;
    initUserSession();
  });

  useEffect(() => {
    const onPageLoad = () => setLoadedWholeApp(true);

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
    }

    return () => {
      window.removeEventListener("load", onPageLoad);
    };
  }, []);

  return (
    <>
      {loadedWholeApp && !isInitializing ? null : (
        <Lottie
          animationData={loadingWholeAppLottie}
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            zIndex: zIndexes.Lottie,
            backgroundColor: ColorVariables.White,
          }}
        />
      )}
      {internalServerError && (
        <Lottie
          animationData={internalServerErrorLottie}
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            zIndex: zIndexes.Lottie,
            backgroundColor: ColorVariables.White,
            cursor: "pointer",
          }}
          onClick={() => window.location.reload()}
        />
      )}
    </>
  );
};
